module.exports = __webpack_public_path__ + "img/ivTest_sub70.760ce63d.jpg";